import { render, staticRenderFns } from "./CloHero.vue?vue&type=template&id=adf3ba04&"
import script from "./CloHero.vue?vue&type=script&lang=js&"
export * from "./CloHero.vue?vue&type=script&lang=js&"
import style0 from "./CloHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports